import React from 'react';
const IconNavIntegrations = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.47 3L16.21 1.5H7.79001L6.53 3H2V5H7.47L8.72 3.5H15.28L16.53 5H20V19H4V7H2V21H22V3H17.47ZM15.83 15L18.35 12L15.83 9H13.22L15.74 12L13.22 15H15.83ZM8.17001 9L5.64999 12L8.17001 15H10.78L8.26001 12L10.78 9H8.17001Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconNavIntegrations;